// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"3d7440ca","787":"824d49bd"}[chunkId] + ".chunk.js";
};